import isEqual from 'lodash/isEqual';

import { arePricesEqual, isCustom } from '@/models/actionType';
import { type ArticleActionWithRelations } from '@/models/request';
import { areSimilar } from '@/utils/array';

export const getEditedFields = ({
  action,
  previousAction,
}: {
  action?: ArticleActionWithRelations;
  previousAction?: ArticleActionWithRelations;
}) => {
  if (!previousAction || !action) {
    return {
      isNameEdited: false,
      isAdditionalInfoEdited: false,
      isContextEdited: false,
      isPhotosEdited: false,
      isDefectsEdited: false,
      isBrandResponsibilityEdited: false,
    };
  }

  return {
    isNameEdited:
      isCustom(action) &&
      isCustom(previousAction) &&
      action.customDescription !== previousAction.customDescription,
    isAdditionalInfoEdited: !isEqual(action.additionalInfo, previousAction.additionalInfo),
    isContextEdited: action.context !== previousAction.context,
    isPhotosEdited: !areSimilar(action.media, previousAction.media, 'id'),
    isDefectsEdited: !areSimilar(
      action.articleActionToArticleDefects.map(({ articleDefect }) => articleDefect) ?? [],
      previousAction.articleActionToArticleDefects.map(({ articleDefect }) => articleDefect) ?? [],
      'stableId'
    ),
    isBrandResponsibilityEdited: action.brandResponsibility !== previousAction.brandResponsibility,
    isCustomWorkshopPriceEdited: !arePricesEqual(
      action.customWorkshopPrice,
      previousAction.customWorkshopPrice
    ),
    isCustomOrganizationPriceEdited: !arePricesEqual(
      action.customOrganizationPrice,
      previousAction.customOrganizationPrice
    ),
  };
};
